import { BusinessError, EntityKind, ErrorKind, ListTeleserviceResponseSchema, TeleserviceSchema, buildBusinessErrorFromError, } from '@mgdis/eu-domain';
export class TeleserviceRestAdapter {
    restHttpAdapter;
    tenantId;
    constructor({ tenantId, restHttpAdapter }) {
        this.tenantId = tenantId;
        this.restHttpAdapter = restHttpAdapter;
    }
    async listAideFormationTeleservice() {
        try {
            const res = await this.restHttpAdapter.get(`/referentiel-financement/api/tenants/${this.tenantId}/teleservices`, {
                params: {
                    $filter: `(statut eq 'PUBLIE' or statut eq 'DESACTIVE') and (surEtablissementFormation eq true)`,
                    $select: 'id,title,reference,statut',
                    $top: 1000,
                    $orderby: 'title asc',
                },
            });
            const result = await ListTeleserviceResponseSchema.safeParseAsync(res.data);
            if (!result.success) {
                return {
                    error: new BusinessError(ErrorKind.TECHNICAL_ERROR, {
                        entity: EntityKind.TELESERVICE,
                        message: `[TeleserviceRestAdapter] listAideFormationTeleservice - Error parsing. ${result.error.message}`,
                    }),
                };
            }
            return { response: result.data._embedded.items };
        }
        catch (error) {
            console.error('[TeleserviceRestAdapter] listAideFormationTeleservice', error);
            return { error: buildBusinessErrorFromError(error, { entityKind: EntityKind.TELESERVICE }) };
        }
    }
    /**
     * Fetch a teleservice from the given reference
     *
     * @param reference - teleservice to fetch
     * @param revisionDate - version of teleservice as ISO format
     * @returns given teleservice (at given date if defined)
     */
    async getTeleservice(reference, revisionDate) {
        const url = `/referentiel-financement/api/tenants/${this.tenantId}/teleservices/${reference}`;
        try {
            const res = await this.restHttpAdapter.get(url, {
                params: { date: revisionDate, $select: 'id,title,reference,statut,workflow' },
            });
            const result = await TeleserviceSchema.safeParseAsync(res.data);
            if (!result.success) {
                return {
                    error: new BusinessError(ErrorKind.TECHNICAL_ERROR, {
                        entity: EntityKind.TELESERVICE,
                        message: `[TeleserviceRestAdapter] getTeleservice - Error parsing. ${result.error.message}`,
                    }),
                };
            }
            return { response: result.data };
        }
        catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Unknown error';
            console.error('[TeleserviceRestAdapter] getTeleservice', errorMessage);
            return { error: buildBusinessErrorFromError(error, { entityKind: EntityKind.TELESERVICE }) };
        }
    }
}
//# sourceMappingURL=teleservice-rest.adapter.js.map